import { render, staticRenderFns } from "./disGroup.vue?vue&type=template&id=25ab4aec&scoped=true&"
import script from "./disGroup.vue?vue&type=script&lang=js&"
export * from "./disGroup.vue?vue&type=script&lang=js&"
import style0 from "./disGroup.vue?vue&type=style&index=0&id=25ab4aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab4aec",
  null
  
)

export default component.exports